<template>
    <div>
        <slot />
        <slot name="btn" :fold="fold" :isFold="isFold" />
        <template v-if="!isFold">
            <slot name="detail" />
        </template>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isFold: !window.FEGOEditor
        };
    },
    methods: {
        fold() {
            this.isFold = !this.isFold
        }
    }
};
</script>
<style lang="scss" scoped>
</style>
